import {deepClone, each, find, formatPrice} from './assist'
import specialUtil from '@os-plugins/utils/specialUtil.js';

export const action = function (product, action = {}) {
  let fn,
    {type, isRequirement} = product,
    {plu, addition, combo, combination} = action;
  type *= 1;
  switch (type) {
    case 1:
      if (isRequirement) {
        fn = addition
        // return addition.call(this, product)
      } else {
        fn = plu
      }
      break;
    case 2:
      fn = combo;
      break;
    case 3:
      fn = combination;
      break;
  }
  fn = fn || function () {
  };
  fn.call(this, product)
};
export const isDisabled = (item, type) => {
  //对餐品进行 时间、售罄、库存不足进行判断
  let {isInServiceTime, isSoldOut, hasStock, stockNum} = item,
    warn = '',
    max = null,
    disabled = true;
  if (!isInServiceTime && type === 1) {
    warn = '不在供应时间'
  } else if (isSoldOut) {
    warn = '已售罄'
  } else if (hasStock && stockNum === 0) {
    warn = '库存不足'
  } else {
    disabled = false
  }
  if (!disabled && hasStock && stockNum > 0) {
    max = stockNum;
    disabled = false
  }
  item.maxNum = max;
  item.warnText = warn;
  item.disabled = disabled
};
export const isType = (item) => {
  //判断类型
  let {isRequirement, type} = item,
    str = '';
  switch (type) {
    case 1:
      str = '单品';
      if (isRequirement) {
        str = '特殊要求'
      }
      break;
    case 2:
      str = '套餐';
      break;
    case 3:
      str = '组合';
      break
  }
  item.typeText = str
};
export const isChange = (item) => {
  // 是否支持菜品修改
  let {type, isRequirement} = item,
    isChange = true;
  if (type === 1 && !isRequirement) {
    isChange = false
  }
  item.isChange = isChange
};
// 计算库存对象合并
export const calculateStockObjMerge = (stockObj, remainStockObj, actionSymbol = '-') => {
  let o = {};
  if (typeof remainStockObj !== 'object') return {...stockObj};
  for (let key in stockObj) {
    if (remainStockObj.hasOwnProperty(key)) {
      o[key] = eval(`${stockObj[key]}${actionSymbol}${remainStockObj[key]}`)
    } else {
      o[key] = stockObj[key]
    }
  }
  return o;
  // 计算库存对象，合并
};
// 公共加料映射
export const getRefIdMap = function (productsRefIdMap = {}, productsUseMaterialStock = {}) {
  // 计算对应公共加料的映射 计算出对应公共加料的使用
  let refIdObj = {};
  if (productsRefIdMap.len) {
    delete productsRefIdMap.len;
    each(productsRefIdMap, (refId, uid) => {
      let num = productsUseMaterialStock[uid] || 0,
        key = 'refId' + refId;
      if (refIdObj.hasOwnProperty(key)) {
        refIdObj[key] += num;
      } else {
        refIdObj[key] = num;
      }
    });
  }
  return refIdObj
};
// 计算套餐的库存
export const calculateComAdditionalStock = function (list, stockObj = {len: 0}, productsStockObj = {len: 0}) {
  // 套餐有库存或者加料的计算
  // 判断产品是否满足
  function isProductMeet(product, productsStockObj, num, stockObj, isCheck = false, errorProducts) {
    let {pid, _additional, hasStock, name} = product, id = pid, additional = _additional, stockMeet = false,
      stockNum = productsStockObj[id] || 0, stockObjEctype = {};
    // 是否特殊要求
    if (additional) {
      let list = _additional.list,
        item = list[0] || additional.param,
        remainStockNum = stockNum - num,
        itemStockObj = item.stockObj;
      // 是否存在加料库存
      if (itemStockObj.len) {
        // 是否需要再次验证 不存在库存  有库存，剩余大于0
        if (!isCheck && (!hasStock || remainStockNum >= 0)) {
          let comboNum = num / item.num;
          item.isSoldOut = false;
          Object.assign(stockObjEctype, calculateAdditionalStockObj([item], stockObj, comboNum));
          calculateAdditionalCorrectionStock([item], stockObjEctype, comboNum, false);
          // 售罄直接返回不行
          if (item.isSoldOut) {
            if (Array.isArray(errorProducts)) errorProducts.push(`${name}中的${item.errorList.join(',')}`);
            return false;
          }
          // 减掉已选的库存，恢复最大能选多少
          calculateAdditionalStockNum([item], stockObjEctype, comboNum);
        }
      }
    }
    if (product.isSoldOut) {
      //售罄直接抛出
      if (Array.isArray(errorProducts)) {
        errorProducts.push(`${name}售罄`)
      }
      return false
    }
    if (!hasStock|| (hasStock&&stockNum - num >= 0)) {
      stockMeet = true
    }
    if (stockMeet) { // 是否满足库存
      if (stockObjEctype.len) { // 存在加料
        Object.assign(stockObj, stockObjEctype)
      }
      if (hasStock)productsStockObj[id] -= num;
      return true;
    } else if (Array.isArray(errorProducts)) {
      errorProducts.push(`${name}库存不足`);
    }
  }
  if (stockObj.len || productsStockObj.len) {
    let additionStock = {...stockObj},
      productsStock = {...productsStockObj},
      groupsData = {};
    // 对每一份是否满足当前的加料和库存配置要求进行判断
    each(list, (item, index) => {
      let {mainList, auxiliaryItem} = item, minList = [], groups = [], groupsObj = {}, errorList = [],
        selectProducts = [], num = item.num * 1,
        stockObj = {...additionStock}, productsStockObj = {...productsStock};
      each(mainList, (item) => {
        // 收集主食
        let group = {groupA: item};
        if (item.mainGroups) Object.assign(group, item.mainGroups);
        groups.push(group);
      });
      if (auxiliaryItem && auxiliaryItem.items) {
        // 收集副食板块
        groups.push(auxiliaryItem.items);
      }
      each(groups, (item) => {
        each(item, (group, groupName) => {
          if (groupsObj[groupName]) groupsObj[groupName].push(group);
          else groupsObj[groupName] = [group];
        })
      });
      // groups 所有板块的集合、 选中或者有数量对其计算 看符合要求
      each(['groupB', 'groupC', 'groupA', 'groupD'], (groupName) => {
        let groups = groupsObj[groupName];
        if (groups) {
          switch (groupName) {
            case 'groupB':
              // 板块B
              each(groups, (group) => {
                let isAllMeet = true, errorProducts = [];// 是否全部满足
                each(group.cells, (product) => {
                  let {pid} = product, productNum = product.num;
                  if (pid) {
                    // 看是否满足当前的要求
                    if (isProductMeet(product, productsStockObj, productNum * num, stockObj, false, errorProducts)) {
                      selectProducts.push(product);
                    } else {
                      // errorProducts.push(`${name}库存不足`);
                      isAllMeet = false
                    }
                  }
                });
                if (!isAllMeet) {
                  minList.push(0);
                  errorList.push(`${group.title}板块(${errorProducts.join(',')})`);
                } // 不满足往数组扔0
              });
              break;
            // 板块A 板块C
            case 'groupA':
            case 'groupC':
              let list = [];
              // C板块是多层 提取出来
              if (groupName === 'groupC') {
                each(groups, group => {
                  let {title} = group;
                  list.push(...group.items.map(item => {
                    item.parentTitle = title;
                    return item;
                  }))
                })
              } else {
                list.push(...groups)
              }
              each(list, (group) => {
                let {checkValue, isNeedSelect, title, parentTitle} = group,
                  errorProducts = [],
                  isAccord = true,
                  cells = group.cells,
                  cellsLen = cells.length;
                  console.log('使用优惠2')
                if (groupName === 'groupA') {
                  isNeedSelect = true;
                  title += '板块中的';
                } else {
                  title = `${parentTitle}板块(${title})选项中的`;
                }
                // 都是单选
                if (cells[checkValue]) {
                  let product = cells[checkValue], {pid} = product, productNum = product.num;
                  if (pid) {
                    // 判断是否符合要求
                    if (isProductMeet(product, productsStockObj, productNum * num, stockObj, false, errorProducts)) {
                      selectProducts.push(product)
                    } else {
                      isAccord = false;
                      console.log('不使用优惠2')
                      // 不符合餐品禁用
                      product.disabled = true;
                    }
                  }
                }
                // 当前选项不符合要求，进入回流重选
                if (!isAccord) {
                  // 如果只存在一个选项，直接抛出
                  if (cellsLen === 1) {
                    minList.push(0);
                    errorList.push(`${title}(${errorProducts.join(',')})`)
                  }
                  else {
                    let isFind = false, cellIndexCheck;
                    //  回流重选
                    each(cells, (product, index) => {
                      let {pid} = product, disabled = false, productNum = product.num;
                      if (!pid) {
                        //  非必选项对应的下标
                        cellIndexCheck = index;
                      }
                      if (index !== checkValue && !isFind && pid) {
                        if (isProductMeet(product, productsStockObj, productNum * num, stockObj, errorProducts)) {
                          checkValue = index;
                          isFind = true;
                          selectProducts.push(product);
                        } else {
                          disabled = true;
                        }
                      }
                      // 修正当前产品的状态
                      product.disabled = disabled;
                    });
                    if (!isFind && !isNeedSelect && typeof cellIndexCheck === 'number') {
                      // 没有找到对应 不是必选 不选的下标是数字 直接应用
                      checkValue = cellIndexCheck;
                      isFind = true
                    }
                    if (!isFind) { // 回流没有找到符合要求的，直接抛出
                      checkValue = null;
                      minList.push(0);
                      errorList.push(`${title}(${errorProducts.join(',')})`);
                    }
                    group.checkValue = checkValue;
                  }
                }
              });
              break;
            // D板块 与B板类似
            case 'groupD':
              each(groups, (group) => {
                let {items} = group,
                  errorItems = [],
                  isAccord = true;
                  console.log('使用优惠2')
                each(items, (item) => {
                  let {title} = item, errorProducts = [];
                  each(item.cells, product => {
                    let productNum = product.num;
                    if (productNum > 0) {
                      if (isProductMeet(product, productsStockObj, productNum * num, stockObj, false, errorProducts)) {
                        selectProducts.push(product);
                      } else {
                        console.log('不使用优惠2')
                        isAccord = false;
                      }
                    } else {
                      selectProducts.push(product);
                    }
                  });
                  if (!isAccord) {
                    errorItems.push(`${title}选项中(${errorProducts.join(',')})`);
                    minList.push(0);
                  }
                });
                if (errorItems.length) {
                  errorList.push(`${group.title}板块(${errorItems.join(',')})`);
                }
              });
              break;
          }
        }
      });
      if (minList.length === 0) {
        Object.assign(additionStock, stockObj);
        Object.assign(productsStock, productsStockObj);
        groupsData[index] = [selectProducts, groupsObj];
      }
      item.errorList = errorList;
      item.isSoldOut = !!minList.length
      // }
    });
    // 对符合的每一份最大份数和其他选项禁用和数量控制的预配置
    each(list, (item, index) => {
      if (groupsData[index]) {
        // @selectProducts选中的产品集合 @groupsObj 板块数据集合 @selectProductsObj餐品分类集合 @maxStockNum 当前最大份数
        let num = Number(item.num),
          comboNum = num,
          [selectProducts, groupsObj] = groupsData[index],
          stockObj = {...additionStock}, productsStockObj = {...productsStock},
          maxStockNum = getComboStockMaxNum(item, stockObj, productsStockObj, selectProducts);
        each(selectProducts, product => {
          if (product._additional) {
            let additional = product._additional, item = additional.list[0], productNum = item.num,
              currentUseStockObj = {};
            if (productNum > 0&&additional&&additional.stockObj.len) {
              each(item.options, option => {
                // 寻找对应选中集合的UID
                let checkValue = option.checkValue, items = option.value.items;
                if(checkValue !== null || (checkValue && checkValue.length!==0)) {
                  checkValue = Array.isArray(checkValue) ? [...checkValue] : [checkValue];
                  each(checkValue, index => {
                    let item = items[index], {uid, refId, num} = item;
                    if (refId > 0) {
                      uid = 'refId' + refId
                    }
                    if (stockObj.hasOwnProperty(uid)) {
                      if (currentUseStockObj[uid]) {
                        currentUseStockObj[uid] +=  (num?num:1)*productNum *comboNum
                      } else {
                        currentUseStockObj[uid] =  (num?num:1)*productNum *comboNum
                      }
                    }
                  })
                }
              });
              // 求当前的加料最大数量
              item.stockMax = getAdditionalStockMaxNum([item], stockObj, productNum).stockMax + productNum;
              // 把剩下的库存 赋值过去
              additional.stockObj = calculateStockObjMerge(stockObj, currentUseStockObj, '+');
              // 当前套餐的份数量
              additional.comboSingleNum = comboNum;
            }
          }
          if (product.pid && product.hasStock) {
            product.stockNum = productsStockObj[product.pid] || 0
          }
        });
        each(['groupB', 'groupC', 'groupA', 'groupD'], (groupName) => {
          let groups = groupsObj[groupName];
          if (groups) {
            switch (groupName) {
              case 'groupA':
              case 'groupC':
                let list = [];
                if (groupName === 'groupC') {
                  each(groups, group => {
                    list.push(...group.items)
                  })
                } else {
                  list.push(...groups)
                }
                each(list, (group) => {
                  let {checkValue} = group,
                    cells = group.cells;
                  each(cells, (product, index) => {
                    let {pid, _additional, disabled} = product;
                    if (pid && index !== checkValue && !product.isSoldOut) {
                      if (_additional) {
                        let additional = _additional,
                          list = additional.list;
                        if (list && list.length && additional.stockObj.len) {
                          // 是否特殊加料
                          let item = list[0],
                            itemStockObj = {...stockObj},
                            count = product.num * num; // 当前数量
                          // if (item.stockObj.len) {
                          item.isSoldOut = false; // 修正售罄字段
                          // 加料预配置下是否能满足当前数量
                          itemStockObj = calculateAdditionalStockObj([item], itemStockObj, count);
                          calculateAdditionalCorrectionStock([item], itemStockObj, count, false);
                          if (item.isSoldOut) {
                            // 不满足禁用
                            return product.disabled = true;
                          }
                          additional.stockObj = {...stockObj};
                          additional.comboSingleNum = num;
                          // }
                        }
                      }
                      if (productsStockObj.hasOwnProperty(pid)) {
                        let productNum = product.num;
                        product.disabled = (productsStockObj[pid] - productNum * num) >= 0 ? false : true;
                        product.stockNum = productsStockObj[pid] || 0
                      }
                    }
                  });
                });
                break;
              case 'groupD':
                // D板块的处理
                each(groups, (group) => {
                  let {items} = group;
                  each(items, (item) => {
                    let {cells} = item, total = 0, parentMaxNum = item.maxNum, remain = 0;
                    if (parentMaxNum > 0) {
                      each(cells, (product) => {
                        total += product.num;
                      });
                      remain = parentMaxNum - total;
                    }
                    each(cells, product => {
                      let {pid, _additional, sourceMaxNum} = product, maxNum = null, minList = [],
                        productNum = product.num, additional = _additional;
                      if (pid && !product.isSoldOut) {
                        if (_additional && _additional.stockObj.len) {
                          let {param, list} = _additional;
                          // 存在特殊要求 分为两种 数量大于0 数量等于0
                          if (productNum > 0) {
                            let item = _additional.list[0], {stockMax} = item;
                            minList.push(Math.floor(stockMax / num)); // 最大的数量集合
                          } else {
                            let item = list[0] || param, count = num, itemStockObj = {...stockObj}, disabled = false;
                            item.num = 1; // 修正数量为1
                            item.isSoldOut = false; // 修正售罄
                            itemStockObj = calculateAdditionalStockObj([item], itemStockObj, count);
                            calculateAdditionalCorrectionStock([item], itemStockObj, count, false);
                            if (item.isSoldOut) {
                              minList.push(0);
                              disabled = true;
                            }
                            product.disabled = disabled;
                            product.warnText = '库存不足';
                            additional.stockObj = {...stockObj};
                            item.num = 0;
                          }
                          additional.comboSingleNum = num;
                        }
                        if (productsStockObj.hasOwnProperty(pid)) {
                          minList.push(Math.floor(productsStockObj[pid] / num) + productNum);
                          product.stockNum = productsStockObj[pid] || 0
                        }
                        if (parentMaxNum > 0) {
                          minList.push(remain + productNum)
                        }
                        if (sourceMaxNum !== null) {
                          minList.push(sourceMaxNum);
                        }
                        if (minList.length === 1) {
                          maxNum = minList[0];
                        } else if (minList.length > 1) {
                          maxNum = Math.min(...minList);
                        }
                        product.buyMaxNum = maxNum;
                        product.forbiddenAdd = maxNum === 0 && productNum === 0;
                      }
                    });
                  })
                });
                break;
            }
          }
        });
        item.stockMax = maxStockNum + num;
        item.isStock = true;
      } else {
        item.num = 0;
      }
    })
  }
};
// 计算餐品加料库存的使用情况
export const calculateAdditionalStockObj = function (list, stockObj, comboNum = 1) {
  // 库存剩余的数量  计算剩余的库存总对象
  // @list 份数集合 stockObj 库存对象 套餐份数 => 返回
  if (stockObj.len) {
    each(list, (item) => {
      let stockObjCopy = {...stockObj};
      if (item.isSoldOut) return;
      let {num} = item, soldOutIds = {}, soldOutLen = 0;
      each(item.options, (option) => {
        let {checkValue, type} = option, cells = option.value.items;
        checkValue = Array.isArray(checkValue) ? checkValue : [checkValue];
        each(checkValue, (index) => {
          let cell;
          if (cell = cells[index]) {
            let { uid, refId } = cell ;
            let reqNum = type =='input' ? (cell.num * num) : num;
            if (refId > 0) {
              uid = 'refId' + refId;
            }
            if (stockObj.hasOwnProperty(uid)) {
              // 存在库存对象中, 进行计算
              let i = stockObj[uid] - (reqNum * comboNum);
              if (i < 0) {
                // 当前库存不满足，扔进去
                soldOutIds[uid] = true;
                return soldOutLen++
              }
              stockObjCopy[uid] = i;
            }
          }
        })
      });
      if (soldOutLen === 0) stockObj = stockObjCopy; // 当不符合的时候， 不进行减
      soldOutIds.len = soldOutLen;
      item.soldOutIds = soldOutIds;
    });
    return stockObj
  }
};
// 当前餐品加料库存不满的时候，进行修正遍历重选
export const calculateAdditionalCorrectionStock = function (list, stockObj, comboNum = 1, isChange = true) {
  // 计算特殊要求库存不满足的时候 进行遍历选择回调 @isChange 不符合的items,是否改变的checkValue 默认是改变的
  each(list, (item) => {
    if (item.isSoldOut) return;
    let {soldOutIds, num, options} = item, isSoldOut = false, stockObjCopy = {...stockObj}, errorList = [];
    num *= comboNum;
    // 不满足选项的当前份数餐品
    if (soldOutIds.len) {
      each(options, (option) => {
        // 找到必选的项
        if (option.type === 'radio') {
          let once = false, checkValue = option.checkValue, disabled = false, {title, items} = option.value;
          // 循环项重选
          each(items, (item, index) => {
            let {uid, refId} = item;
            if (refId > 0) {
              uid = 'refId' + refId;
            }
            if (!soldOutIds[uid] && !once) { // 不存在库存不足的
              if (stockObjCopy.hasOwnProperty(uid)) { // 存在库存的
                let stockNum = stockObjCopy[uid] - (option.type == 'input' ? (item.num * comboNum) : num);
                if (stockNum >= 0) { // 库存满足当前
                  once = true;
                  checkValue = index;
                  stockObjCopy[uid] = stockNum
                }
              } else {
                // 不存在库存
                once = true;
                checkValue = index
              }
            }
          });
          if (!once) {
            disabled = true;
            errorList.push(title + '库存不足');
          }
          option.checkValue = once ? checkValue : isChange ? null : checkValue;
          option.disabled = disabled;
          if (disabled) {
            isSoldOut = true;
          }
        }
      });
      if (!isSoldOut) {
        // 不是售罄状态，移除售罄库存名单
        delete item.soldOutIds;
        Object.assign(stockObj, stockObjCopy);
      }
      item.errorList = errorList;
      item.isSoldOut = isSoldOut;
    }
  });
};
// 计算餐品加料库存的剩余
export const calculateAdditionalStockNum = function (list, stockObj, comboNum = 1) {
  // @list 份数集合 @stockObj 库存对象 //  计算库存剩余的数量
  let isStock = false;
  each(list, (project) => {
    if (project.isSoldOut) return;
    let {options, num} = project, stockMinList = [], isStock = false;
    num *= comboNum;
    each(options, option => {
      // options 特殊要求的每项选择 数据结构option = {disabled, value, checkValue, type}  type 多选和单选  value.items选择结合项
      let {checkValue} = option, obj = {};
      checkValue = Array.isArray(checkValue) ? checkValue : [checkValue];
      // checkValue 选中进行赋值
      each(checkValue, (index) => obj[index] = true);
      each(option.value.items, (item, index) => {
        let {uid, refId} = item, isSoldOut = false, disabled = false, selectNum = option.type == 'input' ? (item.num * comboNum) : num;
        if (refId > 0) {
          uid = 'refId' + refId;
        }
        if (stockObj.hasOwnProperty(uid)) { // 是否存在库存对象中
          let stockNum = stockObj[uid], maxStockNum = stockObj[uid];
          if (obj[index]) {
            // 选中状态 选中最大库存是当前份数+库存对象剩余的份数
            maxStockNum = stockNum + selectNum;
            stockMinList.push(maxStockNum);
            isStock = true;
          }
          disabled = maxStockNum < selectNum;
          item.stockNum = stockObj[uid];
          // item.isSoldOut = !stockNum;
          // 多组多选不需要重新设置售罄
          if(option.type !== 'input') {
            item.disabled = disabled;
          }
          item.stockDisabled = item.stockNum == 0;
        }
      });
    });
    isStock = !!stockMinList.length;
    //stockMax库存最大值 => 取库存集合的最小值
    project.isStock = isStock;
    // project.useRefIdObj = useRefIdObj;
    project.stockMax = isStock ? stockMinList.length < 2 ? stockMinList[0] : Math.min(...stockMinList): Infinity;
  });
};
// 获取当前餐品加料库存支持的最大数量
export const getAdditionalStockMaxNum = function (item, stockObj, num = 0) {
  let options = item.options, minNumList = [], maxNum = 0, usedUid = {};
  each(options, option => {
    let {checkValue} = option, cells = option.value.items;
    checkValue = Array.isArray(checkValue) ? [...checkValue] : [checkValue];
    each(checkValue, (index) => {
      let cell = cells[index], {uid, refId} = cell;
      if (refId > 0) {
        uid = 'refId' + refId;
      }
      if (stockObj.hasOwnProperty(uid)) {
        let stockNum = stockObj[uid];
        minNumList.push(stockNum);
        usedUid[uid] = stockNum;
      }
    });
  });
  if (minNumList.length === 1) maxNum = minNumList[0];
  else maxNum = Math.min(...minNumList);
  maxNum += num;
  return {stockMax: maxNum, usedUid}
};
export const getComboProducts = function (productGroup) {
  let {hasExtArea, mainFoodAreas, extFoodArea} = productGroup,
    m = mainFoodAreas,
    e = hasExtArea ? extFoodArea : null,
    products = [],
    list = [];
  each(m, (value) => {
    // 所有产品合并到列表list
    let {groupA, associatedGroups} = value, once = false;
    groupA&&list.push(...findProductGroup({groupA}));
    each(associatedGroups, (value) => {
      if (!once) {
        once = true;
        list.push(...findProductGroup(value))
      }
    })
  });
  e && list.push(...findProductGroup(e));
  function findProductGroup(o) {
    //对所有餐品进行收集
    let list = [];
    each(o, (value) => {
      let items = value.cells || value.items;
      if (value.cells) {
        list.push(items)
      } else if (value.items) {
        each(items, (value) => {
          let items = value.cells;
          if (items) {
            list.push(items)
          }
        })
      }
    });
    return list
  }
  each(list, (items) => {
    each(items, product => {
      products.push(product)
    })
  });
  return products;
};
// 求当前套餐的最大值
export const getComboStockMaxNum = function (item, productMaterialStock, productStockObj, products) {
  let { mainList, auxiliaryItem} = item, selectProducts = [], minList = [], selectProductsObj = {}, maxStockNum = null, comboNum = item.num * 1, useStockObj = {};
  if (products&&products.length) {
    selectProducts = products
  } else {
    each(mainList, (value) => {
      let {mainGroups} = value;
      calculateGroup(mainGroups, value);
    });
    if (auxiliaryItem) {
      calculateGroup(auxiliaryItem.items)
    }
  }
  function calculateGroup(group = {}, groupA) {
    //cd板块都是cells-items两层结构，A,B对其进行包装成cells-items结构，统一处理
    let  b, list = [];
    if (group) {
      if (b = group.groupB) {
        list.push({...b, items: [b]})
      }
      each(group, (value) => {
        if (value && value.type !== 2) {
          list.push(value)
        }
      });
    }
    if (groupA) {
      list.push({...groupA, items: [groupA]})
    }
    each(list, (project) => {
      each(project.items, (item) => {
        let {checkValue, cells} = item,
          c;
        // 包裹选中为数组模式
        checkValue = Array.isArray(checkValue) ? [...checkValue] : [checkValue];
        c = checkValue.sort((a, b) => a - b); // 排序
        each(c, (value) => {
          let product = cells[value];
          if (!product.num || !product.pid) return;
          selectProducts.push(product)
        });
      });
    });
  }
  each(selectProducts, (product) => {
    // 对同类型的餐品的进行汇集
    let {pid} = product;
    if (selectProductsObj.hasOwnProperty(pid)) selectProductsObj[pid].push(product);
    else selectProductsObj[pid] = [product];
  });
  each(selectProductsObj, (group, pid) => {
    // 循环对应的餐品集合
    let product = group[0], { _additional } = product, stockObj = {...productMaterialStock};
    if (_additional&&_additional.stockObj.len) {
      // 餐品是否有特殊要求 餐品是否存在对应的加料 @useStockObj 当前一份库存使用的列表  @currentUseStockObj总共的使用库存列表
      let productNumList = [];
      each(group, (product) => {
        // 收集所有的加料
        let additional = product._additional;
        if(additional.list && additional.list.length) {

          let item = additional.list[0], productNum = item.num, currentUseStockObj = {};
          if (productNum > 0) {
            each(item.options, option => {
              // 寻找对应选中集合的UID
              let checkValue = option.checkValue, items = option.value.items;
              checkValue = Array.isArray(checkValue) ? [...checkValue] : [checkValue];
              each(checkValue, index => {
                if (items[index]) {
                  let selectItem = items[index], {uid, refId} = selectItem, sNum = selectItem.num;
                  if (refId > 0) {
                    uid = 'refId'+ refId
                  }
                  if (stockObj.hasOwnProperty(uid)) {
                    if (currentUseStockObj[uid]) {
                      currentUseStockObj[uid] +=  sNum ? (sNum*productNum*comboNum) : (productNum*comboNum)
                    } else {
                      currentUseStockObj[uid] = sNum ? (sNum*productNum*comboNum) : (productNum*comboNum);
                    }
                    if (useStockObj[uid]) {
                      useStockObj[uid] += sNum ? sNum : productNum;
                    } else {
                      useStockObj[uid] = sNum ? sNum : productNum;
                    }
                  }
                }
              })
            });
          }
        }
      });
      minList.push(...productNumList);
    }
    if (productStockObj.hasOwnProperty(pid)) {
      // 支持库存
      let stockNum = productStockObj[pid],
        buySingeNum = 0;
      // 当前份用了多少一样的餐品
      each(group, (value) => {
        buySingeNum += value.num;
      });
      if (stockNum === 0 && buySingeNum === 0) minList.push(Infinity); // 存在库存为0和购买数量为0，直接抛无限
      else minList.push(Math.floor(stockNum / buySingeNum));
    }
  });
  // 计算当前的加料，还能添加多少份
  each(useStockObj, (productNum, uid) => {
    if (productMaterialStock.hasOwnProperty(uid)) {
      let total = productMaterialStock[uid], num = productNum;
      minList.push(Math.floor(total / (num === 0 ? 1: num)));
    }
  });
  // 求出当前份数配置最大份数
  if ((Object.values(useStockObj).length === 0 && productStockObj.len === 0)||minList.length === 0) return Infinity; // 餐品里面没有库存，没有加料库存，直接返回无限
  if (minList.length > 1) {
    maxStockNum = Math.min(...minList)
  } else if (minList.length === 1) {
    maxStockNum = minList[0];
  }
  return maxStockNum || (selectProducts.length === 0 && Infinity ) || 0
};
// 特殊要求加料库存的计算
export const calculateAdditionalStock = function (maxNum, list, stockObj, comboNum = 1) {
  // @list 份数列表, o= stockObj 库存对象
  // 计算当前的特殊要求数量
  if (stockObj.len) {
    if (maxNum !== null && typeof maxNum === 'number') {
      // 修正库存
      each(list, item => {
        maxNum -= item.num;
        if (maxNum < 0) {
          item.isSoldOut = true;
        }
      });
      if (maxNum < 0) return;
    }
    stockObj = calculateAdditionalStockObj(list, stockObj, comboNum);
    calculateAdditionalCorrectionStock(list, stockObj, comboNum);
    calculateAdditionalStockNum(list, stockObj, comboNum);
  }
};
// 格式化特殊要求
export const formatProperty = function (product, ) {

  if (product.isRequirement || product.property) {
    let {groupType, price, originOrderPrice} = product,
      property = JSON.parse(JSON.stringify(product.property)),
      disabled = false,
      stockObj = {}, // 当前所有库存集合
      refIdObj = {},
      stockUidNamesObj = {},
      s = property.standard,
      p = property.propertys,
      c = property.choices,
      l = property.choiceList,
      stockLen = 0,
      refIdLen = 0,
      num = 1,
      list = [];
      
      let radios = [s];
    if (Array.isArray(p) && p.length) {
      radios.push(...p)
    }
    // 必选的radio
    radios.forEach(value => {
      if (value) {
        list.push({type: 'radio', value, checkValue: null, disabled: false})
      }
    });
    // 多选的可选
    if (c) list.push({type: 'checkbox', value: c, checkValue: [], disabled: null});
    // 多组多选
    if (Array.isArray(l) && l.length) {
      l.forEach(value => {
        value.items.forEach(i => i.num = 0 );
        list.push({type: 'input', value, checkValue: (value.isMultipleChoice ? [] : null), disabled: false})
      })
    }
    list.forEach(project => {
      let once = false, {items} = project.value;
      if (project.type === 'radio') {
        if (groupType) {
          project.checkValue = 0
        } else {
          for (let i = 0; i < items.length; i++) {
            let item = items[i],
              {hasStock, isSoldOut, stockNum} = item;
            if (!isSoldOut || (hasStock && stockNum)) {
              once = true;
              project.checkValue = i;
              break;
            }
          }
          if (!once) {
            // 没有一个符合，当前项目禁用
            project.disabled = true;
            disabled = true; // 直接禁用当前餐品
          }
        }
      }
      items.forEach((item) => {
        let {hasStock, stockNum, uid, refId, isSoldOut, name} = item;
        item.disabled = !!item.disabled;
        if (isSoldOut) {
          // 修正售罄 不支持库存
          item.hasStock = true;
          item.stockNum = 0;
          hasStock = true;
        }
        if (hasStock) {
          stockUidNamesObj[uid] = name;
          stockObj[uid] = isSoldOut ? 0 : stockNum;
          stockLen++;
          if (refId > 0) {
            refIdObj[uid] = refId;
            refIdLen++;
            stockObj['refId' + refId] = stockObj[uid];
          }
        }
      })
    });
    // 套餐版本类型 groupType 1  2  3数量禁止变化
    if (groupType === 1 || groupType === 2 || groupType === 3) {
      disabled = true;
    }
    stockObj.len = stockLen;
    refIdObj.len = refIdLen;
    return {
      disabled, options: list, num, stockObj, price, originOrderPrice, refIdObj, stockUidNamesObj: {}
    }
  }
};
//对库存进行计算限制
export const calculateProductMax = function (o) {
  let {list, maxNum} = o;
  if (maxNum !== null) {
    let count = 0,
      remain;
    each(list, (value) => {
      count += Number(value.num)
    });
    remain = maxNum - count;
    each(list, (value) => {
      let num = Number(value.num) + remain;
      value.maxNum = value.isStock ? Math.min(value.stockMax, num) : num;
    })
  } else {
    each(list, (value) => {
      if (value.isStock) {
        value.maxNum = value.stockMax;
      }
    })
  }
};
// 创建特殊要求
export const createAdditional = function (product, num, ) {
  let additionOptions = product.additionOptions = product.additionOptions || formatProperty(product, ),
    additionalObj = {},
    total = 0,
    item = {...additionOptions, ...calculateAdditional(additionOptions)},
    list = [{...item}],
    totalProductPrice = 0,
    {name, _key, maxNum, isSoldOut, hasStock, stockNum} = product, title = `特殊要求-${name}`, key = _key || '';
  maxNum = isSoldOut ? 0 : hasStock ? stockNum : null;
  if (typeof num === 'number') {
    let item = list[0];
    item.num = num;
    item.totalCurrentProductPrice = item.pricing * num;
    total = num;
  }
  list.forEach(item => {
    totalProductPrice += item.totalCurrentProductPrice
  });
  Object.assign(additionalObj, {
    type: 1,
    single: false,
    title,
    key,
    list: [deepClone(list[0])], // 防止数组变成对象
    maxNum,
    param: item,
    totalProductPrice,
    total,
    stockObj: {...additionOptions.stockObj},
    refIdObj: {...additionOptions.refIdObj}
  });
  return additionalObj;
};
// 计算所有特殊要求
export const calculateAllAdditional = function (product, additional) {
  let {list} = additional, // list 数据列表 最大值
    totalProductPrice = 0, // 统计价格
    count = 0, // 总数量
    listRequirements = [],
    o = {},
    index = 0,
    items = [],
    unique = [], // 独特的编码
    desc = [];
  each(list, (value, index) => {
    // 执行一次过滤 0的抛弃
    if (value.num) {
      let num = value.num * 1,
        current = calculateAdditional(value), // 计算单个特殊要求
        {unique} = current,
        obj = {current, num: num, index, item: value};
      if (o[unique]) {
        // 相同的编码 直接覆盖原来
        obj.num = num + o[unique].num
      }
      count += num;
      o[unique] = obj
    }
  });
  each(o, (value, key) => {
    let {num, current, item} = value,
      {maxNum} = item,
      {itemRequirements, pricing} = current;
    if (maxNum && num > maxNum) {
      item.maxNum = num; // 修正最大份数
    }
    // 计算当前份数还能添加多少份
    item.num = num; // 修正数量
    desc.push(...(item.desc = current.desc));
    listRequirements.push({index, propertys: itemRequirements, num});
    totalProductPrice += item.totalProductPrice = item.totalCurrentProductPrice = formatPrice(pricing * num);//全部总价
    item.pricing = pricing;
    item._index = index; // 合并后的第几份
    items.push(item);
    unique.push(key);
    index++;
  });
  list.splice(0, list.length, ...items); // 修正的最新结果返回到list
  if (list.length > 0 && !find(list, (value) => {
    return value.active
  })) list[0].active = true; // 修正list有值但是没有选中
  totalProductPrice = formatPrice(totalProductPrice);
  additional.totalProductPrice = totalProductPrice; // 总价
  additional.total = count;
  product._additional = deepClone(additional);// 计算完毕，深拷贝返回
  product.listRequirements = listRequirements;
  product.totalProductPrice = totalProductPrice; //总价
  product.num = count; // 数量
  product.unique = unique.join('-'); // 编码
  product.desc = desc; // 餐品集合
  return product
};
// 计算单份特殊要求
export const calculateAdditional = (additionOptions, ) => {
  let {options, num, price, originOrderPrice} = additionOptions, pricing = price * 1 || 0,  desc = [], unique = [], products = [],
    totalCurrentProductPrice;

  let hasOriginOrderPrice = originOrderPrice >= 0; //  是否有原订单价格信息
  let originOrderPricing =  hasOriginOrderPrice ? originOrderPrice : null;

  options.forEach(project => {
    let checkValue = project.checkValue,
      {uid, title} = project.value, o = {pid: uid, items: []}, names = [];
    checkValue = typeof  project.checkValue !== 'object' ? [checkValue] : checkValue;
    if (Array.isArray(checkValue)) {
      checkValue.forEach(index => {
        let {items} = project.value,
          item = items[index],
          {uid, name, price, originOrderPrice, num} = item;
        unique.push(uid); // 唯一ID
        let rqName = project.type == 'input' ? `${name}*${num}` : name;
        names.push(rqName); // 名字集合
        // names.push(name); // 名字集合
        let itemObj = {uid, name, price};
        if( project.type == 'input' && num) {
          itemObj.selectNum = num;
          itemObj.num = num;
        }
        o.items.push(itemObj); // 选中产品组集合

        let pricingNum = num;
        let bePricing = price * (num ? num : 1);

        if(project.value.isGiveAway && item.freeNum > 0) {
          pricingNum = Math.max(num - item.freeNum, 0);
          bePricing = pricingNum * price;
        }

        pricing += bePricing;
        if(hasOriginOrderPrice && originOrderPrice >= 0) {
          originOrderPricing += originOrderPrice;
        }
      });
      if (checkValue.length) {
        // desc.push(`${title}：${names.join('-')}`);
        desc.push(`${names.join('/')}`);
        products.push(o)
      }
    }
  });
  unique = unique.join('-');
  pricing = formatPrice(pricing);
  totalCurrentProductPrice = num * pricing;
  // 所选产品集合 描述 特殊编码 当前产品价格共计
  return {itemRequirements: products, desc, unique, totalCurrentProductPrice, pricing, originOrderPricing};
};
// 创建套餐
export const createCombo = function (product, num, ) {

  let comboOptions = product.comboOptions = product.comboOptions || formatCombo(product, ),
    comboObj = {},
    total = 0,
    item = {...comboOptions},
    list = [{...item}],
    totalProductPrice = 0,
    {name, pid, _key, maxNum, isSoldOut, hasStock, stockNum} = product, title = `套餐-${name}`, key = _key || '';
  Object.assign(comboObj, {
    type: 2,
    title,
    key,
    list: [deepClone(list[0])],
    maxNum,
    param: item,
    totalProductPrice,
    total,
    productMaterialStock: item.productMaterialStock,
    productStockObj: item.productStockObj,
    productRefIds: item.productRefIds
  });
  return comboObj;
};
// 计算全部套餐
export const calculateAllCombo = function (product, combo) {
  let {list} = combo,
    {mealFee = 0} = product,
    totalProductPrice = 0,
    count = 0,
    o = {},
    index = 0,
    items = [],
    unique = [], // 独特的编码
    groups = []; // 套餐集合
  each(list, (value, index) => {
    // 执行一次过滤 0的抛弃
    if (value.num) {
      let num = value.num * 1,
        current = calculateCombo(deepClone(value)), // 计算单个特殊要求
        {unique} = current,
        obj = {current, num: num, index, item: {...value, products: current.products}};
      if (o[unique]) {
        // 相同的编码 直接覆盖原来
        obj.num = num + o[unique].num
      }
      count += num;
      o[unique] = obj
    }
  });
  each(o, (value, key) => {
    let {num, current, item} = value,
      {maxNum} = item,
      {pricing, mains, exArea} = current;
    if (maxNum && num > maxNum) {
      item.maxNum = num; // 修正最大份数
    }
    // 计算当前份数还能添加多少份
    item.num = num; // 修正数量
    totalProductPrice += item.totalProductPrice = item.totalCurrentProductPrice = formatPrice(pricing * num);//全部总价
    item.pricing = pricing;
    item._index = index; // 合并后的第几份
    items.push(item);
    groups.push({index, mains, exArea, num});
    unique.push(key);
    index++;
  });
  if (items.length) {
    list.splice(0, list.length, ...items); // 修正的最新结果返回到list
    list[0].active = true; // 修正list有值但是没有选中
  }
  totalProductPrice = formatPrice(totalProductPrice);
  combo.total = count;
  product.groups = groups;
  product.totalPrice = formatPrice(totalProductPrice + count * mealFee);
  product.totalMealFee = count * mealFee;
  product.totalProductPrice = totalProductPrice;
  product.num = count;
  product._combo = deepClone(combo);
};
//计算单份套餐
export const calculateCombo = (comboOptions) => {
  // @mainList 主食列表 @auxiliaryItem副食列表
  let {auxiliaryItem, mainList, num, price} = comboOptions,
    // stockAdditionalProducts = {}, //有库存的特殊要求
    pricing = price || 0, // 单价
    error = false, // 错误标示
    errorList = [], // 错误列表
    unique = [], // 唯一标示
    products = [], // 餐品列表
    mains = [],
    totalCurrentProductPrice,
    exArea = {};
  each(mainList, (value) => {
    let {areaId, title, mainGroups} = value,
      groups = calculateGroup(mainGroups, value);
    mains.push({
      name: title, mid: areaId, groups
    })
  });
  if (auxiliaryItem) {
    exArea = {title: auxiliaryItem.title, groups: calculateGroup(auxiliaryItem.items)}
  }

  function calculateGroup(group = {}, groupA) {
    //cd板块都是cells-items两层结构，A,B对其进行包装成cells-items结构，统一处理
    let groups = [], b, list = [];
    if (groupA) {
      list.push({...groupA, items: [groupA]})
    }
    if (group) {
      if (b = group.groupB) {
        list.push({...b, items: [b]})
      }
      each(group, (value) => {
        if (value && value.type !== 2) {
          list.push(value)
        }
      });
    }
    each(list, (project) => {
      let {type, title} = project,
        selectProducts = [];
      each(project.items, (item, itemIndex) => {
        let {checkValue, cells, minNum, maxNum} = item,
          groupType = item.type * 1,
          c,
          count = 0;
        // 包裹选中为数组模式
        checkValue = Array.isArray(checkValue) ? checkValue : [checkValue];
        c = checkValue.sort((a, b) => a - b); // 排序
        each(c, (value) => {
          let index = value,
            product = cells[index],
            {pid, price, name, num, property, UUID} = product,
            o = {itemIndex, index, pid, price, name, num};
          if (!num || !pid) return;
          if (property && product._additional) {
            // 特殊要求的计算与收集
            calculateAllAdditional(product, product._additional);
            pricing += product.totalProductPrice || 0;
            o.listPropertys = product.listRequirements;
            num = product.num;
            UUID += product.unique;
            o.desc = product.desc
          } else {
            pricing += price * num
          }
          UUID += `-${num}-`;
          products.push(o);
          selectProducts.push(o);
          count += num;
          unique.push(UUID)
        });
        if (groupType === 4 && maxNum > 0) {
          let productTotal = 0, remain = 0;
          each(cells, (value) => {
            productTotal += value.num * 1;
          });
          remain = maxNum - count;
          each(cells, (cell) => {
            if (cell.hasStock || (cell._additional && cell._additional.stockObj.len)) return;
            let {sourceMaxNum} = cell, num = cell.num * 1;
            cell.maxNum = cell.buyMaxNum = sourceMaxNum === null ? (remain + num) : Math.min(sourceMaxNum, (remain + num));
          });
          if (!(minNum <= productTotal && productTotal <= maxNum)) {
            error = true;
            errorList.push(item)
          }
        }
      });
      if (products.length > 0) groups.push({type, name: title, products: selectProducts})
    });
    // 板块排序
    groups.sort(function (a, b) {
      return a.type - b.type
    });
    return groups
  }

  pricing = formatPrice(pricing);
  totalCurrentProductPrice = pricing * num;
  return {
    mains,
    exArea,
    pricing,
    totalCurrentProductPrice,
    error,
    errorList,
    unique: unique.join('-'),
    products
  }
};
// 初始化套餐
export const formatCombo = (product, ) => {
  let UUID = 0,// 标识
    productRefIds = {}, // 公共加料集合
    productRefIdLen = 0, // 公共加料长度
    productMaterialStock = {},  // 餐品加料集合
    productStockObj = {}, // 餐品库存集合
    productStockLen = 0, // 餐品库存长度
    productMaterialStockLen = 0, //  加料长度
    additionalObj = {}, // 特殊要求库，防止多次添加
    {price} = product,
    {hasExtArea, mainFoodAreas, extFoodArea} = product.productGroup,
    m = mainFoodAreas,
    e = hasExtArea ? extFoodArea : null,
    mainList = [],
    comboObj = {},
    auxiliaryItem;
  isAdditional(m, e);

  function isAdditional(m, e) {
    //判断是否有特殊需求 对特殊需求的产品进行初始化
    let list = [];
    each(m, (value) => {
      // 所有产品合并到列表list
      let {groupA, associatedGroups} = value, once = false;
      if (!groupA) {
        // 没有主食的时候，模拟主食进去
        groupA = value.groupA = {
          maxNum: 0,
          title: '主食版块',
          type: 1,
          hide: true,
          cells: [
            {
              hasStock: false,
              isSoldOut: false,
              maxNum: 1,
              name: '模拟',
              nameEn: '',
              pid: 0,
              price: 0,
              status: 1,
              stockNum: 0,
              type: 1
            }
          ]
        }
      }
      list.push(...findProductGroup({groupA}));
      each(associatedGroups, (value) => {
        if (!once) {
          once = true;
          list.push(...findProductGroup(value))
        }
      })
    });
    e && list.push(...findProductGroup(e));
    each(list, (items) => {
      // 过滤有特殊要求的，并附上默认的附加要求的价格和份数
      each(items, (value, index) => {
        // 给每件餐品附上标记以及判断是否售罄
        let {pid, num} = value;
        value.UUID = UUID++;
        value.maxNum = value.buyMaxNum; // 修正当前最大值
        if (value.hasStock && !productStockObj.hasOwnProperty(pid)) {
          productStockLen++;
          productStockObj[pid] = value.stockNum
        }
        //console.log(value, value.property && !value.disabled)
        if (value.property && !value.disabled) {
          // 特殊要求处理 是否有加料 是否有库存，是否有公共加料
          let additional = createAdditional(value, num), {stockObj, refIdObj} = additional;
          value._additional = additional;
          value.totalProductPrice = additional.totalProductPrice;
          // 餐品本身价格/加价
          additional.productPrice = value.price||0;
          if (!additionalObj.hasOwnProperty(pid) && stockObj.len > 0) {
            additionalObj[pid] = true;
            Object.assign(productMaterialStock, stockObj);
            productMaterialStockLen += stockObj.len;
            if (refIdObj.len > 0) {
              Object.assign(productRefIds, refIdObj);
              productRefIdLen += refIdObj.len;
            }
          }
          //计算特殊要求
          items[index] = value
        }
      });
    });
  }

  function findProductGroup(o) {
    //对所有餐品进行收集
    let list = [];
    each(o, (value, key) => {
      switch (key) {
        case 'groupA':
          initGroupA(value);
          break;
        case 'groupB':
          initGroupB(value);
          break;
        case 'groupC':
          initGroupC(value);
          break;
        case 'groupD':
          initGroupD(value);
          break
      }
      let items = value.cells || value.items;
      if (value.cells) {
        list.push(items)
      } else if (value.items) {
        each(items, (value) => {
          let items = value.cells;
          if (items) {
            list.push(items)
          }
        })
      }
    });
    return list
  }

  // @buyMinNum 最小购买数量  @buyMaxNum 最大购买数量
  function setProductABCNum(o, type, groupType) {
    // 统一处理产品的ABC板块
    let checkValue = type === 'radio' ? 0 : [], i = 0;
    each(o.cells, (cell, index) => {
      let num = cell.maxNum;
      Object.assign(cell, {
        groupType,
        num: num,
        buyMinNum: num,
        buyMaxNum: num
      });
      isDisabled(cell);
      if (!Array.isArray(checkValue)) {
        if (i === 0 && !cell.disabled) {
          checkValue = index;
          i++
        }
      } else {
        if (!cell.disabled) checkValue.push(index)
      }
    });
    o.checkValue = checkValue
  }

  //ABCD板块分组处理
  function initGroupA(o) {
    //  A板块 num = maxNum
    setProductABCNum(o, 'radio', 1);
  }

  function initGroupB(o) {
    //初始化B板块D板块
    setProductABCNum(o, 'checkbox', 2)
  }

  function initGroupC(o) {
    //初始化C板块
    let {type} = o,
      items = o.items;
    each(items, (item) => {
      let {canSelectNum} = item;
      item.groupType = type;
      each(item.cells, (cell) => cell.maxNum = canSelectNum);
      setProductABCNum(item, 'radio', 3);
      if (!item.isNeedSelect) { // 是否必选
        item.cells.unshift({name: '--不选--', groupType: type});
        item.checkValue = 0
      }
    })
  }

  function initGroupD(o) {
    let {type, items} = o;
    each(items, (value) => {
      let {maxNum, minNum, cells} = value,
        checkValue = [];
      value.type = type;
      value.isWarn = false;
      value.warnText = `最少选择${minNum}份,最多选择${maxNum}份`;
      each(cells, (cell, index) => {
        // 参数等于0为表示当前没有份数限制
        let sourceMaxNum = cell.maxNum, {stockNum, hasStock} = cell, buyMaxNum;
        cell.num = 0;
        cell.groupType = type;
        cell.buyMinNum = 0;
        buyMaxNum = hasStock ? sourceMaxNum === 0 ? stockNum : Math.min(stockNum, sourceMaxNum) : sourceMaxNum === 0 ? null : sourceMaxNum; // 当前餐品能选购的最大值
        cell.sourceMaxNum = buyMaxNum;
        cell.buyMaxNum = maxNum === 0 ? buyMaxNum : buyMaxNum === null ? maxNum : Math.min(buyMaxNum, maxNum); // 在item的限制下，实际最大能多少份
        isDisabled(cell);
        if (!cell.disabled) checkValue.push(index)
      });
      value.checkValue = checkValue
    })
  }

  each(m, (value) => {
    //对主食板块进行处理，让各自的BCD板块附属在A板块上
    let groupA = value.groupA,
      item = {
        ...groupA,
        areaId: value.areaId,
        cells: [],
      },
      associatedGroups = value.associatedGroups,
      o = null,
      once = false,
      cells = groupA.cells;
    each(associatedGroups, (item, key) => {
      if (!once) {
        once = true;
        o = associatedGroups[key]
      }
    });
    each(cells, (cell) => {
      item.cells.push(cell)
    });
    item.mainGroups = o;
    mainList.push(item);
  });
  if (e) {
    //副食版本拉出来，单独放在vice
    let {title, groupB, groupC, groupD} = e,
      group = {groupB, groupC, groupD};
    auxiliaryItem = {title: title, items: group};
  }
  //初始化，对其默认的套餐进行求值，写入
  comboObj.mainList = mainList;
  productMaterialStock.len = productMaterialStockLen;
  productStockObj.len = productStockLen;
  Object.assign(comboObj, {
    mainList,
    auxiliaryItem,
    num: 1,
    price,
    productMaterialStock: productMaterialStock,
    productStockObj: productStockObj,
    productRefIds: productRefIds
  });
  return comboObj
};
//获取餐品的加料
export const getAdditionalUseMaterial = (list, productUseMaterialStock = {}, comboNum = 1) => {
  //  获取餐品特殊要求的加料
  each(list, (item) => {
    let {num} = item;
    each(item.propertys, (project) => {
      each(project.items, (cell) => {
        let {uid} = cell;
        productUseMaterialStock[uid] = (productUseMaterialStock[uid] || 0) + ((cell.selectNum ? cell.selectNum*num : num) * comboNum)
      })
    })
  });
  return productUseMaterialStock
};
// 获取套餐餐品和加料
export const getComboUseProductsAndMaterial = (groups, productUseNum = {}, productUseMaterialStock = {}) => {
  // 获取套餐已购餐品数量以及特殊要求的加料
  each(groups, (group) => {
    let {num, mains, exArea} = group, list = [];
    // 副食
    if (exArea && exArea.groups) {
      list.push(...exArea.groups)
    }
    // 主食
    if (Array.isArray(mains)) {
      each(mains, main => {
        let {groups} = main;
        if (groups && groups.length) list.push(...groups);
      })
    }
    each(list, item => {
      each(item.products, (product) => {
        let {pid} = product;
        productUseNum[pid] = (productUseNum[pid] || 0) + product.num * num;
        if (Array.isArray(product.listPropertys)&&product.listPropertys.length) {
          getAdditionalUseMaterial(product.listPropertys, productUseMaterialStock, num)
        }
      })
    });
  });
  return {productUseNum, productUseMaterialStock}
};
//检查是否套餐的特殊要求多组多选是否已选
export const checkChoiceListSelect = (comboOptions) => {
  // @mainList 主食列表 @auxiliaryItem副食列表
  let {auxiliaryItem, mainList, products} = comboOptions,
    error = false, // 错误标示
    errorList = [], // 错误列表
    mains = [],
    exArea = {};
  let selectProId = [];
  if(products && products.length) {
    products.map(p => {return p.pid});
  }
  each(mainList, (value) => {
    let {areaId, title, mainGroups} = value;
    mains.push({
      name: title, mid: areaId, groups:calculateGroup(mainGroups, value, selectProId)
    })
  });
  if (auxiliaryItem) {
    exArea = {title: auxiliaryItem.title, groups: calculateGroup(auxiliaryItem.items, {}, selectProId) }
  }

  function calculateGroup(group = {}, groupA) {
    //cd板块都是cells-items两层结构，A,B对其进行包装成cells-items结构，统一处理
    let b, list = [];
    if (groupA) {
      list.push({...groupA, items: [groupA]})
    }
    if (group) {
      if (b = group.groupB) {
        list.push({...b, items: [b]})
      }
      each(group, (value) => {
        if (value && value.type !== 2) {
          list.push(value)
        }
      });
    }
    each(list, (project) => {
      each(project.items, (item) => {
        let {cells, checkValue} = item;
        checkValue = Array.isArray(checkValue) ? checkValue : [checkValue];
        each(cells, (value,cIndex) => {
          let product = value, requireChoiceList = [],
            { name, property, num} = product;
          if (property && product._additional && num > 0 && checkValue.includes(cIndex)) {
            // 检查多组多选必选是否已选
            each(product._additional.list, (additional)=> {
              if(additional.options) {
                each(additional.options, (option)=> {
                  option.value.selectNum = option.value.items.reduce((a,b)=>Number(a)+Number(b.num || 0), 0);
                  if(option.value.isRequired && option.type == 'input' && 
                      ((Object.prototype.toString.call(option.checkValue) == '[object Null]' && !option.value.isMultipleChoice) || 
                      (Object.prototype.toString.call(option.checkValue) == '[object Array]' && ((option.checkValue.length == 0 || ( option.checkValue && option.value.selectNum < option.value.minRequiredNum)) && option.value.isMultipleChoice)))
                  ) {
                    requireChoiceList.push(option.value.title+`请最3少选择${option.value.minRequiredNum}份`)
                  }
                })
              }
            })
            if(requireChoiceList.length) {
              error = true;
              item.warnText = name + '特殊要求' + ":" + requireChoiceList.join(",");
              errorList.push(item);
            }
            
          }
        
        });
     
      });
    });
    return list
  }
  return {
    error,
    errorList,
  }
}


// WEBPACK FOOTER //
// ./utils/productAction.js